module.exports = __webpack_public_path__ + "static/img/logo-light-blue.51f41ab.svg";